import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { instantItems } from '../data/content';
export function InstantAccess() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-117" data-mp="2582nt2k0r622">
      <div className="mx-auto max-w-2xl" data-id="element-118" data-mp="1r9uhw5508uer">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-119" data-mp="1r8t4hu0invtv">
          <span aria-hidden="true" data-id="element-120" data-mp="1hjjfin0yyt9z">📲 </span>What Do You Get Instantly?
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-121" data-mp="1hhgdf4mjl9ow">
          {instantItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 text-sm font-medium text-ink/85" data-id="element-122" data-mp="1mc2spivqvme9">
              <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-123" data-mp="1cl8262bgu0n0" />
              {item}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-124" data-mp="13i6z6ahwcpnk">
          You cover the full CEFR spectrum for all ages in one click.
        </p>
      </div>
    </section>;
}